import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";

export type WalletType = "entries" | "withdrawals" | "all";

export const fetchWalletStatement = createAsyncThunk(
  "subscriptionWallet/fetchWalletStatement",
  async (
    {
      params,
    }: {
      params: {
        start_date?: string;
        end_date?: string;
        type?: WalletType;
        page?: number;
        per_page?: number;
      };
    },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.get(
        `/subscriptions/wallet/statement`,
        { params },
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({
          error: error.response?.data || error.message,
          status: error.response?.status,
        });
      }
      return thunkAPI.rejectWithValue({
        error: "Erro desconhecido ao buscar extrato da carteira",
      });
    }
  },
);

export const fetchWalletBalanceWithdrawals = createAsyncThunk(
  "subscriptionWallet/fetchWalletBalanceWithdrawals",
  async (
    {
      params,
    }: {
      params: {
        start_date?: string;
        end_date?: string;
        page?: number;
        per_page?: number;
      };
    },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.get(
        `/subscriptions/wallet/balance-withdrawals`,
        { params },
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({
          error: error.response?.data || error.message,
          status: error.response?.status,
        });
      }
      return thunkAPI.rejectWithValue({
        error: "Erro desconhecido ao buscar saldo e saques",
      });
    }
  },
);

type StatementBySourceParams = {
  start_date?: string;
  end_date?: string;
  page_manual?: number;
  per_page_manual?: number;
  page_asaas?: number;
  per_page_asaas?: number;
  page_pix?: number;
  per_page_pix?: number;
};

export const fetchWalletStatementBySource = createAsyncThunk(
  "subscriptionWallet/fetchWalletStatementBySource",
  async (
    {
      establishmentIdentifier,
      params,
    }: {
      establishmentIdentifier?: number | string | null;
      params: StatementBySourceParams;
    },
    thunkAPI,
  ) => {
    try {
      const identifier =
        establishmentIdentifier != null && establishmentIdentifier !== ""
          ? String(establishmentIdentifier)
          : null;

      const basePath = identifier
        ? `/establishment/${identifier}/subscriptions/wallet/statement-by-source`
        : `/subscriptions/wallet/statement-by-source`;
      const response = await axiosInstance.get(basePath, { params });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({
          error: error.response?.data || error.message,
          status: error.response?.status,
        });
      }
      return thunkAPI.rejectWithValue({
        error: "Erro desconhecido ao buscar extrato por origem",
      });
    }
  },
);
